export default function Footer() {
  return (
    <div className="container-fluid px-0">
      <div className="row">
        <div className="col-12">
          <div className="footer text-center" >
            <p>© Copy Rights 2025 APCFSS. All Rights Reserved. </p>
          </div>
        </div>
      </div>
    </div>
  )
}
 